import { useEffect, useState } from "react";
import Card from "../../components/Card";
import { Product } from "../../models/product";
import { Button, InputNumber, Select, Typography, message } from "antd";
import { AuthService } from "../../services/AuthService";
import Search from "antd/es/input/Search";


const { Text } = Typography;
const UpdateStock = () => {

    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);


    const [stock, setStock] = useState({
        stockId: 0,
        storeId: null,
        productId: null,
        barcode: null,
        quantity: null
    })

    const [product, setProduct] = useState<Product>({
        id: null,
        productId: null,
        name: null,
        barcode: null,
        productNo: null,
        description: null,
        categoryId: null,
        brandId: null,
        price: null,
        discount: 0,
        discountedPrice: null,
        storeId: null,
        quantity: null,
        storeStocks: null,
        stocks: null
    })

    const [stores, setStores] = useState([]);


    const getProductDetails = async () => {

        if (!product?.barcode) {
            messageApi.open({
                type: 'error',
                content: 'Shenoni barkodin per kerkim..',
            });
            return;
        }
        setSearchLoading(true);
        let res = await AuthService.getProductDetails(product?.barcode);
        console.log("getProductDetails", res);
        if (res && res?.barcode) {
            setProduct(res);
            setStock({...stock, productId: res?.productId, barcode: res?.barcode,})
        }
        else {
            messageApi.open({
                type: 'error',
                content: 'Nuk u gjet asnje produkt me shifren qe keni shenuar',
            });
            setProduct({ ...product, barcode: null })
        }
        setSearchLoading(false)
    }

    const getStores = async () => {
        // setLoading(true);
        let res = await AuthService.getStores({});
        console.log("get stores", res);
        if (res && res.items && res.items.length > 0) {
            setStores(res.items);
        }
        return [];
        // setLoading(false)
    }


    const moveStock = async () => {
        // const { productId, quantityToMove, sourceStoreId, destinationStoreId } = stockMove;

        const {productId, barcode, quantity, storeId} = stock

        if (!productId || !barcode || !quantity || !storeId) {
            alert("ka gabim");
            return;
        }
        setLoading(true);
        let res = await AuthService.createStock(stock)

        console.log("res", res)
        if (res) {
            setLoading(false);
            messageApi.open({
                type: 'success',
                content: res?.message,
            });
        }
    }


    useEffect(()=>{
        getStores();
    }, [])






    return (
        <div className="row">
            {/* <p>{JSON.stringify(product)}</p> */}
            {contextHolder}
            <div className="col-lg-10">
                <Card title="Perditesim stoku">
                    <div className="row">

                        <div className="col-6 mt-0">
                            <Text>Shifra e prodhuesit *</Text>
                            <Search value={product?.barcode} onChange={(e) => setProduct({ ...product, barcode: e.target.value })} onSearch={() => getProductDetails()} loading={searchLoading} />
                        </div>
                        <div className="col-12"> </div>

                        <div className="col-6 mt-3">
                            <Text>Pika shitese</Text>
                            <Select
                                labelInValue
                                defaultValue={product?.storeId}
                                style={{ width: "100%" }}
                                disabled={!product?.productId}
                                onChange={(e: any) => {
                                    setStock({ ...stock, storeId: e?.value })
                                }}
                                options={stores ? stores.map(item => ({
                                    value: item?.storeId,
                                    label: item?.storeName
                                })) : []}
                            />
                        </div>



                        <div className="col-lg-6 mt-3">
                            <Text className="d-block">Sasia e produktit</Text>
                            <InputNumber disabled={!stock?.productId || !stock?.barcode || !stock?.storeId} min={0} value={stock?.quantity} style={{ width: "100%" }} className="quantity-input" onChange={(e) => {
                                setStock({ ...stock, quantity: e })
                            }} />

                        </div>
                        <div className="col-12 mt-3">
                            <div className="d-flex justify-content-end">
                                <Button loading={loading} disabled={!stock?.productId || !stock?.barcode || !stock?.storeId} type="primary" onClick={() => moveStock()}>Perfundo</Button>
                            </div>
                        </div>

                    </div>
                </Card>
            </div>
        </div>
    )
}

export default UpdateStock;